export default __webpack_public_path__ + "img/default-d6684ff2.png";